import { ColumnDef } from '@tanstack/react-table';
import { Checkbox } from '@/components/ui/checkbox';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Channel, ChannelGuide } from '@/lib/schema/channelGuide';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { MoreHorizontal } from 'lucide-react';
import { format } from 'date-fns';
import { cloneChannelGuide, deleteChannelGuide } from '@/lib/api/channelGuide';

export const columns: ColumnDef<ChannelGuide>[] = [
  {
    id: 'select',
    header: ({ table }) => (
      <Checkbox
        checked={
          table.getIsAllPageRowsSelected() ||
          (table.getIsSomeRowsSelected() && 'indeterminate')
        }
        onCheckedChange={(value) => table.toggleAllRowsSelected(!!value)}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: 'name',
    header: ({ column }) => (
      <div
        onClick={() =>
          column.toggleSorting(column.getIsSorted() == 'asc', false)
        }
      >
        Name
      </div>
    ),
    cell: ({ row }) => <div className="capitalize">{row.getValue('name')}</div>,
  },
  {
    accessorKey: 'channels',
    header: ({ column }) => (
      <div
        onClick={() =>
          column.toggleSorting(column.getIsSorted() == 'asc', false)
        }
      >
        Channels
      </div>
    ),
    cell: ({ row }) => {
      const channels: Channel[] = row.getValue('channels');
      return <div className="capitalize">{channels?.length}</div>;
    },
  },
  {
    accessorKey: 'createdAt',
    header: ({ column }) => (
      <div
        onClick={() =>
          column.toggleSorting(column.getIsSorted() == 'asc', false)
        }
      >
        Created
      </div>
    ),
    cell: ({ row }) => {
      const createdAt = row.getValue('createdAt') as Date | null;
      return (
        <div>{createdAt ? format(createdAt, 'MMM d, yyyy HH:mm') : '—'}</div>
      );
    },
  },
  {
    accessorKey: 'id',
    header: 'Actions',
    cell: ({ row }) => (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="h-8 w-8 p-0">
            <span className="sr-only">Open menu</span>
            <MoreHorizontal />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuLabel>Actions</DropdownMenuLabel>
          <DropdownMenuItem asChild>
            <Link
              className="cursor-pointer"
              to={`/channel-guides/${row.getValue('id')}`}
            >
              Edit
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => cloneChannelGuide(row.getValue('id'))}
          >
            Clone
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={() => deleteChannelGuide(row.getValue('id'))}
          >
            Delete
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    ),
  },
];
